import Button from "../../../SharedComponents/Button";

import { BUTTON_VARIANT_TYPES } from "../../../../utils/constants";
import { DownloadIcon } from '@heroicons/react/solid';

function SubsequentFileRow(props) {
    const { documentIdentifier, subsequentFile, handleDownloadSubsequentFile, currentlyDownloading } = props;
 
    return (
        <tr>
            <td className="px-4 py-3 whitespace-nowrap">
                <div className="flex flex-row gap-4 items-center">
                    <div className="text-sm text-blue-gray-500 mt-1">
                        {subsequentFile.name}
                    </div>
                </div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap">
                <div className="flex flex-row gap-4 items-center">
                    <div className="text-sm text-blue-gray-500 mt-1">
                        {subsequentFile.fileFormat.toUpperCase()}
                    </div>
                </div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap">
                <div className={"flex flex-row gap-3 items-center"}>
                    <Button
                        onClick={() => handleDownloadSubsequentFile(documentIdentifier, subsequentFile.identifier, subsequentFile.fileFormat)}
                        iconPositionLeft
                        icon={<DownloadIcon className="block h-3.5 w-3.5 mr-2" />}
                        colour={BUTTON_VARIANT_TYPES.UNCOLOURED}
                        text="Download"
                        extraStyling="shadow-none text-primary-600 p-0 focus:ring-0 focus:transparent"
                        loading={currentlyDownloading === subsequentFile.identifier}
                        disabled={currentlyDownloading}
                    />
                </div>
            </td>
        </tr>
    )
}

export default SubsequentFileRow;